module.exports = {
      id: "logo-usage",
      viewBox: "0 0 137 23",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#logo",
      toString: function () {
        return this.url;
      }
    }